const FALLBACK_BACKEND_URL = "http://127.0.0.1:8000";

const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();
// In production, prefer same-origin API routes so a static deploy doesn't call localhost.
const fallbackBackendUrl =
  process.env.NODE_ENV === "production" ? "" : FALLBACK_BACKEND_URL;

export const API_BASE_URL = (configuredBackendUrl || fallbackBackendUrl).replace(
  /\/+$/,
  "",
);

export const API_URL = API_BASE_URL ? `${API_BASE_URL}/api` : "/api";
